import { Component, OnInit, Input, AfterContentInit, Output, EventEmitter, AfterViewInit} from '@angular/core';
import { SimpleInputBlockItemBase } from '../../../../core/models/physician/form-doc-builder';

@Component({
  selector: 'app-form-block-input',
  templateUrl: './form-block-input.component.html',
  styleUrls: ['./form-block-input.component.scss']
})
export class FormBlockInputComponent implements OnInit, AfterContentInit {
  @Input() blockItem: SimpleInputBlockItemBase;
  @Output() onChange = new EventEmitter<SimpleInputBlockItemBase>();

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    this.setValues();
  }


  setValues() {
    if (!this.blockItem.type) {
      this.blockItem.type = 0;
    }

    if (!this.blockItem.html5InputType) {
      this.blockItem.html5InputType = 'text';
    }

  }

  valueChanged(value) {
    //console.log('valuechanged', value);
    if (value && value.length>0)
      this.onChange.emit(this.blockItem);
    return true;
  }

}
